import { useCallback, useRef, useState } from 'react';

import type {
  CollectionAnimationCompetitionQuery,
  CollectionAnimationCompetition_anyCardInterface,
} from './__generated__/index.graphql.ts';

export const useTranslateY = ({
  sortedNewCards,
  displayedCardCollections,
}: {
  sortedNewCards: CollectionAnimationCompetition_anyCardInterface[];
  displayedCardCollections: NonNullable<
    NonNullable<
      CollectionAnimationCompetitionQuery['currentUser']
    >['competitionCardCollections']
  >[number]['cardCollections'];
}) => {
  const clubsTopRef = useRef<number[]>(null);

  const [translateY, setTranslateY] = useState<number>(0);

  const scrollTo = (cardIndex: number) => {
    const card = sortedNewCards.at(cardIndex);
    const collectionIndex = displayedCardCollections.findIndex(cardCollection =>
      cardCollection.userCardCollection.slots.some(
        slot => slot.highlightedCardCollectionCard?.anyCard.slug === card?.slug
      )
    );
    if (collectionIndex === -1) {
      return;
    }
    const firstItemY = clubsTopRef.current?.[0] || 0;
    const itemY = clubsTopRef.current?.[collectionIndex] || 0;
    setTranslateY(firstItemY - itemY);
  };

  const clubRefCallback = useCallback(
    (ref: HTMLDivElement, index: number) => {
      if (!clubsTopRef.current) {
        clubsTopRef.current = Array.from(
          { length: displayedCardCollections.length },
          () => 0
        );
      }
      clubsTopRef.current[index] = ref.getBoundingClientRect().top || 0;
    },
    [displayedCardCollections.length]
  );

  return {
    translateY,
    clubRefCallback,
    scrollTo,
  };
};
